<div class="col-md-2">
  <button
    class="mt-3 btn font-size-12 button-btn"
    (click)="printSection('printSection')"
  >
    <i class="fa fa-print mr-1" style="font-size: medium; cursor: pointer"></i>
    Print
  </button>
</div>

<div class="container" id="printSection">
  <div class="header">
    <img
      src="../../../assets/images/experion_logo.png"
      alt="Experian Logo"
      width="150"
      style="mix-blend-mode: multiply"
    />
    <h2>Experian Credit Report</h2>
  </div>

  <div class="report-info">
    <p>
      <span style="color: #87ceeb">Report Date:</span>
      {{ creditProfileHeader?.ReportDate }}
    </p>
    <p>
      <span style="color: #87ceeb">Report Time:</span>
      {{ creditProfileHeader?.ReportTime }}
    </p>
    <p>
      <span style="color: #87ceeb">Report Number:</span>
      {{ creditProfileHeader?.ReportNumber }}
    </p>
  </div>

  <div class="section-title">CURRENT APPLICATION INFORMATION</div>

  <table>
    <tr>
      <td class="bold">Name -</td>
      <td style="color: black">
        {{
          currentApplicationInformation?.First_Name +
            " " +
            currentApplicationInformation?.Last_Name
        }}
      </td>
      <td class="bold">Date of Birth -</td>
      <td style="color: black">
        {{ currentApplicationInformation?.Date_Of_Birth_Applicant }}
      </td>
      <td class="bold">Ration Card -</td>
      <td style="color: black">-</td>
    </tr>
    <tr>
      <td class="bold">Mobile Phone -</td>
      <td style="color: black">
        {{ currentApplicationInformation?.MobilePhoneNumber }}
        <!-- {{ formatDate(customerDOB) }} -->
      </td>
      <td class="bold">PAN -</td>
      <td style="color: black">
        {{ currentApplicationInformation?.IncomeTaxPan }}
      </td>
      <td class="bold">Driving License -</td>
      <td style="color: black">-</td>
    </tr>
    <tr>
      <td class="bold">Passport Number -</td>
      <td style="color: black">-</td>
      <td class="bold">Voter ID -</td>
      <td style="color: black">-</td>
    </tr>
    <tr>
      <td class="bold">Email -</td>
      <td style="color: black">
        {{ currentApplicationInformation?.EMailId }}
      </td>
      <td class="bold">Aadhaar Number -</td>
      <td style="color: black">-</td>
    </tr>
  </table>

  <div class="score-container">
    <div class="section-title">EXPERIAN CREDIT SCORE</div>
    <p>
      Your Experian Credit Report is summarized in the form of Experian Credit
      Score which ranges from 300 - 900.
    </p>

    <div class="score-content">
      <span style="margin-top: 130px; margin-right: -45px; font-weight: 600"
        >300</span
      >
      <div class="gauge-container">
        <div class="gauge">
          <p style="width: 20px; height: 20px; color: blue"></p>
          <div
            class="needle"
            [ngStyle]="{
              transform: 'rotate(' + needleRotation + 'deg)'
            }"
          ></div>
        </div>
      </div>
      <span style="margin-top: 130px; font-weight: 600; margin-left: -50px"
        >900</span
      >

      <div class="score-value">{{ creditScoreExperian }}</div>

      <div class="score-factors">
        <h3>Score Factors</h3>
        <p>
          <span style="color: #555555 !important"><b>1. Recency:</b></span>
          <span style="color: rgb(33, 31, 31) !important"
            >Recent Credit Account Defaults</span
          >
        </p>
        <p>
          <span style="color: #555555 !important"><b>2. Leverage:</b></span>

          <span style="color: rgb(33, 31, 31) !important"
            >Credit Accounts with on-time re-payment history</span
          >
        </p>
        <p>
          <span style="color: #555555 !important"><b>3. Coverage:</b></span>
          <span style="color: rgb(33, 31, 31) !important">
            Non-delinquent and delinquent Credit Accounts</span
          >
        </p>
        <p>
          <span style="color: #555555 !important"
            ><b>4. Delinquency Status:</b></span
          >
          <span style="color: rgb(33, 31, 31) !important">
            Defaults on Credit Accounts (current & recent periodic
            intervals)</span
          >
        </p>
        <p>
          <span style="color: #555555 !important"
            ><b>5. Credit Applications:</b></span
          >
          <span style="color: rgb(33, 31, 31) !important"
            >Credit Account Applications over last 30 days</span
          >
        </p>
      </div>
    </div>
  </div>

  <div class="section-title">REPORT SUMMARY</div>
  <div class="report-summary">
    <div class="summary-box">
      <h4>Credit Account Summary</h4>
      <p>
        Total number of Accounts -
        <span>{{ creditAccountSummaryDetails?.CreditAccountTotal }}</span>
      </p>
      <p>
        Active Accounts -
        <span>{{ creditAccountSummaryDetails?.CreditAccountActive }}</span>
      </p>
      <p>
        Closed Accounts -
        <span>{{ creditAccountSummaryDetails?.CreditAccountClosed }}</span>
      </p>
      <p>
        SF/WD/WO/SET/RES -
        <span>{{
          creditAccountSummaryDetails?.CADSuitFiledCurrentBalance
        }}</span>
      </p>
    </div>
    <div class="summary-box">
      <h4>Current Balance Amount Summary</h4>
      <p>
        Total Current Bal. amt -
        <span>{{ currentBalanceAccountSummary?.Outstanding_Balance_All }}</span>
      </p>
      <p>
        SF/WD/WO/Settled amt -
        <span></span>
      </p>
      <p>
        Secured Accounts amt -
        <span>{{
          currentBalanceAccountSummary?.Outstanding_Balance_Secured
        }}</span>
      </p>
      <p>
        Unsecured Accounts amt -
        <span>{{
          currentBalanceAccountSummary?.Outstanding_Balance_UnSecured
        }}</span>
      </p>
    </div>
    <div class="summary-box">
      <h4>Credit Enquiry Summary</h4>
      <p>
        Last 7 days credit enquiries -
        <span>{{ creditEnquirySummaryDetail?.CAPSLast7Days }}</span>
      </p>
      <p>
        Last 30 days credit enquiries -
        <span>{{ creditEnquirySummaryDetail?.CAPSLast30Days }}</span>
      </p>
      <p>
        Last 90 days credit enquiries -
        <span>{{ creditEnquirySummaryDetail?.CAPSLast90Days }}</span>
      </p>
      <p>
        Last 180 days credit enquiries -
        <span>{{ creditEnquirySummaryDetail?.CAPSLast180Days }}</span>
      </p>
    </div>
    <div class="summary-box">
      <h4>Non-Credit Enquiry Summary</h4>
      <p>
        Last 7 days non-credit enquiries -
        <span>{{ nonCreditEnquirySummaryDetail?.NonCreditCAPSLast7Days }}</span>
      </p>
      <p>
        Last 30 days non-credit enquiries -
        <span>{{
          nonCreditEnquirySummaryDetail?.NonCreditCAPSLast30Days
        }}</span>
      </p>
      <p>
        Last 90 days non-credit enquiries -
        <span>{{
          nonCreditEnquirySummaryDetail?.NonCreditCAPSLast90Days
        }}</span>
      </p>
      <p>
        Last 180 days non-credit enquiries -
        <span>{{
          nonCreditEnquirySummaryDetail?.NonCreditCAPSLast180Days
        }}</span>
      </p>
    </div>
  </div>

  <div class="section-title">SUMMARY</div>
  <p class="highlight">
    This section displays summary of all your reported credit accounts found in
    the Experian Credit Bureau database
  </p>
  <table class="summary-table">
    <thead>
      <tr>
        <th>Sr.no</th>
        <th style="width: 120px !important">Account Type</th>
        <th>Account No</th>
        <th style="width: 70px !important">Date Reported</th>
        <th>Account Status</th>
        <th style="width: 70px !important">Date Opened</th>
        <th>Currency Code</th>
        <th>Sanction Amt / Highest Credit</th>
        <th>Current Balance</th>
        <th>Overdue Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let summary of summaryCreditAccountsArr; let i = index">
        <td style="color: black">Acc{{ i + 1 }}</td>
        <td style="color: black">{{ summary?.Account_Type }}</td>
        <td style="color: black">{{ summary?.Account_Number }}</td>

        <td style="color: black">
          {{ formatDate(summary?.Date_Reported) }}
        </td>
        <td style="color: black">{{ summary?.Account_Status }}</td>

        <td style="color: black">
          {{ formatDate(summary?.Open_Date) }}
        </td>
        <td style="color: black">{{ summary?.CurrencyCode }}</td>
        <td style="color: black">
          {{ summary?.Highest_Credit_or_Original_Loan_Amount }}
        </td>
        <td style="color: black">{{ summary?.Current_Balance }}</td>
        <td style="color: black">{{ summary?.Amount_Past_Due }}</td>
      </tr>
    </tbody>
  </table>

  <div class="section-title">CREDIT ACCOUNT INFORMATION DETAILS</div>
  <p class="highlight">
    This section has information based on the details provided to Experian by
    all our member banks, credit / financial institutions and other credit
    grantors with whom you have a credit / loan account.
  </p>

  <div *ngFor="let summaryDetails of summaryCreditAccountsArr; let i = index">
    <div class="box">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <p class="title">
          {{
            summaryDetails.CAIS_Holder_Details[0]?.Surname_Non_Normalized +
              "" +
              summaryDetails.CAIS_Holder_Details[0]
                ?.Middle_Name_1_Non_Normalized
          }}
        </p>

        <div>
          <span class="tick">✔ Acct :</span> <span>{{ i + 1 }}</span>
        </div>
      </div>

      <p>
        <span class="title">Address -</span>
        <span>{{
          summaryDetails?.CAIS_Holder_Address_Details[0]
            ?.First_Line_Of_Address_non_normalized +
            " " +
            summaryDetails?.CAIS_Holder_Address_Details[0]
              ?.Second_Line_Of_Address_non_normalized +
            "" +
            summaryDetails?.CAIS_Holder_Address_Details[0]
              ?.Third_Line_Of_Address_non_normalized
        }}</span>
      </p>
    </div>

    <div style="margin-top: 10px">
      <p
        style="
          color: #2d76c9;
          font-size: 18px;
          font-weight: 600;
          border-bottom: 0.5px solid rgb(158, 158, 158);
        "
      >
        Credit Account details
      </p>
    </div>

    <div class="table-container">
      <div class="table-box">
        <p class="title" style="border-bottom: 2px solid gray">Account Terms</p>
        <div class="info-row">
          <span>Account Number:</span>
          <span style="color: black">{{ summaryDetails?.Account_Number }}</span>
        </div>
        <div class="info-row">
          <span>Date Opened:</span>
          <span style="color: black">{{ summaryDetails?.Open_Date }}</span>
        </div>
        <div class="info-row">
          <span>Date Closed:</span>
          <span style="color: black">{{
            summaryDetails?.Date_Closed ? summaryDetails?.Date_Closed : "-"
          }}</span>
        </div>

        <div class="info-row">
          <span>Ownership:</span>
          <span style="color: black">-</span>
        </div>
        <div class="info-row">
          <span>Rate of Interest: </span>
          <span style="color: black">{{
            summaryDetails?.Rate_of_Interest
              ? summaryDetails?.Rate_of_Interest
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Value of Collateral: </span>
          <span style="color: black">{{
            summaryDetails?.Value_of_Collateral
              ? summaryDetails?.Value_of_Collateral
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Type of Collateral: </span>
          <span style="color: black">{{
            summaryDetails?.Type_of_Collateral
              ? summaryDetails?.Type_of_Collateral
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>SuitFiled Willful Default WrittenOff Status: </span>
          <span style="color: black">{{
            summaryDetails?.SuitFiledWillfulDefaultWrittenOffStatus
              ? summaryDetails?.SuitFiledWillfulDefaultWrittenOffStatus
              : "-"
          }}</span>
        </div>
      </div>
      <div class="table-box">
        <p class="title" style="border-bottom: 2px solid gray">
          Account Description
        </p>
        <div class="info-row">
          <span>Date Reported:</span>
          <span style="color: black">{{
            summaryDetails?.Date_Reported ? summaryDetails?.Date_Reported : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Loan Type:</span>
          <span style="color: black">-</span>
        </div>
        <div class="info-row">
          <span>Account Status:</span>
          <span style="color: black">{{
            summaryDetails?.Account_Status
              ? summaryDetails?.Account_Status
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Current Balance:</span>
          <span style="color: black">{{
            summaryDetails?.Current_Balance
              ? summaryDetails?.Current_Balance
              : "-"
          }}</span>
        </div>

        <div class="info-row">
          <span>Amount Overdue:</span>
          <span style="color: black">{{
            summaryDetails?.Amount_Past_Due
              ? summaryDetails?.Amount_Past_Due
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Last Payment Date: </span>
          <span style="color: black">{{
            summaryDetails?.Date_of_Last_Payment
              ? summaryDetails?.Date_of_Last_Payment
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>SuitFiled Willful Default: </span>
          <span style="color: black">{{
            summaryDetails?.SuitFiled_WillfulDefault
              ? summaryDetails?.SuitFiled_WillfulDefault
              : "-"
          }}</span>
        </div>
      </div>
      <div class="table-box">
        <p class="title" style="border-bottom: 2px solid gray">
          Account Details
        </p>
        <div class="info-row">
          <span>Credit Limit Amt:</span>
          <span style="color: black">{{
            summaryDetails?.Credit_Limit_Amount
              ? summaryDetails?.Credit_Limit_Amount
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Repayment Tenure:</span>
          <span style="color: black">{{
            summaryDetails?.Repayment_Tenure
              ? summaryDetails?.Repayment_Tenure
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Total Write-off Amt:</span>
          <span style="color: black">{{
            summaryDetails?.Written_Off_Amt_Total
              ? summaryDetails?.Written_Off_Amt_Total
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Principal Write-off:</span>
          <span style="color: black">{{
            summaryDetails?.Written_Off_Amt_Principal
              ? summaryDetails?.Written_Off_Amt_Principal
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Settlement Amt: </span>
          <span style="color: black">{{
            summaryDetails?.Settlement_Amount
              ? summaryDetails?.Settlement_Amount
              : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span>Written off Settled Status:</span>
          <span style="color: black">{{
            summaryDetails?.Written_off_Settled_Status
              ? summaryDetails?.Written_off_Settled_Status
              : "-"
          }}</span>
        </div>
      </div>
    </div>

    <div style="margin-top: 10px">
      <p style="color: #2d76c9; font-size: 18px; font-weight: 600">
        Payment History
      </p>
    </div>

    <table>
      <thead>
        <tr>
          <th style="border: 1px solid #dcd7d7">Year</th>
          <th *ngFor="let month of months" style="border: 1px solid #dcd7d7">
            {{ month.value }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let year of summaryDetails.CAIS_Account_History.yearData">
          <td class="year-column" style="border: 1px solid #dcd7d7">
            {{ year.Year }}
          </td>
          <td
            *ngFor="let month of year.Month; let i = index"
            style="border: 1px solid #dcd7d7"
          >
            <span
              *ngIf="month.data != undefined"
              [ngClass]="{
                'green-circle': month.data == 0,
                'orange-circle': month.data > 0
              }"
            >
              {{ month.data }}
            </span>
            <span *ngIf="month.data == undefined"></span>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="margin-top: 10px">
      <p style="color: #2d76c9; font-size: 18px; font-weight: 600">
        Consumer Personal details on the Credit Account
      </p>
    </div>

    <div style="width: 100%; border: 1px solid rgb(167, 159, 159)">
      <table style="width: 100%; border-collapse: collapse; border: none">
        <tr>
          <td style="font-weight: bold; padding: 8px; text-align: left">
            Date of Birth
          </td>
          <td
            style="
              padding: 8px;
              text-align: left;
              color: black;
              width: max-content !important;
            "
          >
            {{ formatDate(customerDOB) }}
          </td>
          <td style="padding: 8px; text-align: left">Phone Type</td>
          <td style="padding: 8px; text-align: left">Phone Number</td>
          <td style="padding: 8px; text-align: left">Extension</td>
          <td style="padding: 8px; text-align: left">Phone Type</td>
          <td style="padding: 8px; text-align: left">Phone Number</td>
          <td style="padding: 8px; text-align: left">Extension</td>
          <td style="padding: 8px; text-align: left">ID Type</td>
          <td style="padding: 8px; text-align: left">ID Number</td>
          <td style="padding: 8px; text-align: left">Date of Issue</td>
          <td style="padding: 8px; text-align: left">Date of Expiry</td>
        </tr>
        <tr>
          <td
            style="
              font-weight: bold;
              width: 200px;
              padding: 8px;
              text-align: left;
            "
          >
            Gender
          </td>

          <td style="padding: 8px; text-align: left; color: black">
            {{ customerGender == 1 ? "Male" : "Female" }}
          </td>
          <td style="padding: 8px; text-align: left; color: black">
            {{ summaryDetails?.CAIS_Holder_Phone_Details?.[0]?.Telephone_Type ? summaryDetails?.CAIS_Holder_Phone_Details?.[0]?.Telephone_Type : '-' }}
          </td>
          <td style="padding: 8px; text-align: left; color: black">
            {{ summaryDetails?.CAIS_Holder_Phone_Details?.[0]?.Mobile_Telephone_Number ? summaryDetails?.CAIS_Holder_Phone_Details?.[0]?.Mobile_Telephone_Number : '-' }}
          </td>

          <td style="padding: 8px; text-align: left; color: black">
            {{ summaryDetails?.CAIS_Holder_Phone_Details?.[0]?.Telephone_Extension ? summaryDetails?.CAIS_Holder_Phone_Details?.[0]?.Telephone_Extension : '-' }}
          </td>

          <td style="padding: 8px; text-align: left; color: black">
            {{ summaryDetails?.CAIS_Holder_Phone_Details?.[1]?.Telephone_Type ? summaryDetails?.CAIS_Holder_Phone_Details?.[1]?.Telephone_Type : '-' }}
          </td>
          <td style="padding: 8px; text-align: left; color: black">
            {{ summaryDetails?.CAIS_Holder_Phone_Details?.[1]?.Mobile_Telephone_Number ? summaryDetails?.CAIS_Holder_Phone_Details?.[1]?.Mobile_Telephone_Number : '-' }}
          </td>

          <td style="padding: 8px; text-align: left; color: black">
            {{ summaryDetails?.CAIS_Holder_Phone_Details?.[1]?.Telephone_Extension ? summaryDetails?.CAIS_Holder_Phone_Details?.[1]?.Telephone_Extension : '-' }}
          </td>

          <td style="padding: 8px; text-align: left">PAN</td>
          <td style="padding: 8px; text-align: left; color: black">
            {{ summaryDetails?.CAIS_Holder_ID_Details[0].Income_TAX_PAN }}
          </td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
        </tr>
        <tr>
          <td
            style="
              font-weight: bold;
              width: 200px;
              padding: 8px;
              text-align: left;
            "
          >
            Occupation
          </td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">Passport</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
        </tr>
        <tr>
          <td
            style="
              font-weight: bold;
              width: 200px;
              padding: 8px;
              text-align: left;
            "
          >
            Email Address
          </td>
          <td style="padding: 8px; text-align: left; color: black">
            {{ summaryDetails?.CAIS_Holder_Phone_Details?.[0]?.EMailId ? summaryDetails?.CAIS_Holder_Phone_Details?.[0]?.EMailId : '-' }}
          </td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">Voter ID</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
        </tr>
        <tr>
          <td
            style="
              font-weight: bold;
              width: 200px;
              padding: 8px;
              text-align: left;
            "
          ></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">Aadhaar UID</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
        </tr>
        <tr>
          <td
            style="
              font-weight: bold;
              width: 200px;
              padding: 8px;
              text-align: left;
            "
          ></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">Driving License</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
        </tr>
        <tr>
          <td
            style="
              font-weight: bold;
              width: 200px;
              padding: 8px;
              text-align: left;
            "
          ></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left"></td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">Ration Cards</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
          <td style="padding: 8px; text-align: left">-</td>
        </tr>
      </table>
    </div>
  </div>

  <div class="section-title">CREDIT ENQUIRIES</div>
  <p class="highlight">
    This section shows the names of the credit institutions that have processed
    a credit / loan application for you.
  </p>

  <div *ngFor="let summaryDetails of summaryCreditAccountsArr; let i = index">
    <div
      style="
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
        padding: 10px;
        margin-top: 10px;
        background: #fff;
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <p class="title">
          {{
            summaryDetails.CAIS_Holder_Details[0]?.Surname_Non_Normalized +
              "" +
              summaryDetails.CAIS_Holder_Details[0]
                ?.Middle_Name_1_Non_Normalized
          }}
        </p>

        <div>
          <span class="tick">✔ Cr Enq :</span>
          <span>{{ i + 1 }}</span>
        </div>
      </div>

      <p>
        <span class="title">Address -</span>
        <span>{{
          summaryDetails?.CAIS_Holder_Address_Details[0]
            ?.First_Line_Of_Address_non_normalized +
            " " +
            summaryDetails?.CAIS_Holder_Address_Details[0]
              ?.Second_Line_Of_Address_non_normalized +
            "" +
            summaryDetails?.CAIS_Holder_Address_Details[0]
              ?.Third_Line_Of_Address_non_normalized
        }}</span>
      </p>
    </div>

    <hr />

    <table>
      <tr>
        <td class="bold">Date of Birth</td>
        <td style="color: black">{{ formatDate(customerDOB) }}</td>
        <td class="bold">PAN</td>
        <td style="color: black">
          {{ summaryDetails?.CAIS_Holder_ID_Details[0].Income_TAX_PAN }}
        </td>
        <td class="bold">ERN</td>
        <td>-</td>
      </tr>
      <tr>
        <td class="bold">Telephone</td>
        <td>-</td>
        <td class="bold">Passport Number</td>
        <td>-</td>
        <td class="bold">Search Type</td>
        <td>-</td>
      </tr>
      <tr>
        <td class="bold">Mobile Phone</td>
        <td style="color: black">{{ customerPhoneNumber }}</td>
        <td class="bold">Voter ID -</td>
        <td>-</td>
        <td class="bold">Credit Institution Name</td>
        <td>-</td>
      </tr>
      <tr>
        <td class="bold">Gender</td>
        <td style="color: black">
          {{ customerGender == 1 ? "Male" : "Female" }}
        </td>
        <td class="bold">Driving License</td>
        <td>-</td>
        <td class="bold">Application Date</td>
        <td>-</td>
      </tr>
      <tr>
        <td class="bold">Ration Card</td>
        <td>-</td>
        <td class="bold">Amount Applied For</td>
        <td>-</td>
      </tr>

      <tr>
        <td class="bold">Duration of Agreement</td>
        <td>-</td>
      </tr>
    </table>
  </div>

  <div class="section-title">NON-CREDIT ENQUIRIES</div>
  <p class="highlight">
    This section shows non-credit enquiries such as authentication requests and
    request for your Experian Credit Report & Credit Score by you
  </p>

  <div class="section-title">CONTACTING US</div>
  <p
    class="highlight"
    style="color: #262aff !important; line-height: 1.5; font-weight: 400"
  >
    If you find a discrepancy in your report, it is important to quickly raise
    it with your lender.Under the Credit Information Companies (Regulation) Act
    2005 and as per the guidelines set by the Reserve Bank of India, Experian
    Credit Information Company of India Private Limited is not authorized to
    change any data in your credit information report without authorisation from
    your lender. However, we would be happy to help you with this process. If
    you would like us to help please visit https://consumer.experian.in/ECV-OLN/
    to raise a dispute regarding the discrepancy
  </p>

  <div class="section-title">LEGEND</div>

  <div class="legend-container">
    <ul class="legend-list">
      <li>
        <b>SF/WD/WO/SET/RES:</b>
        <ul>
          <li style="color: #3498db">Credit Accounts that are Suit Filed.</li>
          <li style="color: #3498db">Wilful Default.</li>
          <li style="color: #3498db">Written Off.</li>
          <li style="color: #3498db">Settled.</li>
          <li style="color: #3498db">Restructured.</li>
        </ul>
      </li>
      <li>
        <b style="color: #3498db">Active*:</b> Credit accounts which are less
        than 90 days past due.
      </li>
      <li>
        <b style="color: #3498db">Active**:</b> Credit accounts which are over
        90 days past due.
      </li>
      <li>
        <b style="color: #3498db">Closed:</b> Credit accounts that have 'Date
        Closed' populated.
      </li>
      <li>
        <b style="color: #3498db">DPD:</b> Days Past Due. Number of days that
        have passed from the agreed payment due date of EMI.
      </li>
      <li>
        <b style="color: #3498db">DPD '0':</b> The number '0' in the circle
        indicates that the Payment is made as agreed and the credit account is
        up to date.
      </li>
      <li>
        <b style="color: #3498db">DPD >0:</b> The number in the circle indicates
        the "Days Past Due" reported by the respective lender.
      </li>
      <li>
        <b style="color: #3498db"
          >When the below alphabets are shown in the DPD table, it means the
          lender is reporting Asset Classification and indicates the
          following:</b
        >
        <ul>
          <li>
            <b style="color: #3498db">S:</b>
            <span style="color: #3498db"
              >Standard. An account which is overdue for less than 90 days is
              considered a Standard asset as per RBI guidelines.</span
            >
          </li>
          <li>
            <b style="color: #3498db">M:</b>
            <span style="color: #3498db"
              >Special Mention. These accounts are "Standard" assets but for
              some discrepancy the lending organization would like to monitor
              this account closely.</span
            >
          </li>
          <li>
            <b style="color: #3498db">B:</b>
            <span style="color: #3498db"
              >Substandard. An account which is overdue by 90 days for a period
              of less than or equal to 12 months is classified as Substandard
              asset as per RBI guidelines.</span
            >
          </li>
          <li>
            <b style="color: #3498db">D:</b>
            <span style="color: #3498db">
              Doubtful. An account which is overdue by 90 days for more than 12
              months is classified as Doubtful asset as per RBI
              guidelines.</span
            >
          </li>
          <li>
            <b style="color: #3498db">L:</b>
            <span style="color: #3498db">
              Loss. An account where loss has been identified but the amount has
              not been written off, wholly or partially, is classified as Loss
              asset as per RBI guidelines.</span
            >
          </li>
        </ul>
      </li>
    </ul>
  </div>

  <div>
    <p
      style="
        text-align: center;
        color: gray;
        font-size: 12px;
        margin-top: 8px;
        font-weight: 400;
      "
    >
      <---------- END OF REPORT ----------->
    </p>
    <p style="color: #2d76c9; font-size: 12px">
      Experian Credit Information Company of India Private Limited ("ECICI") is
      registered as a Credit Information Company with the Reserve Bank of India.
      ECICI has empanelled several credit institutions / specified users
      ("Members") with it, from whom it collects information / data for the
      bureau operations. The current Experian Credit Information Report and
      Experian Credit Score ("Report") is a reflection of this information /
      data as submitted by the Member to ECICI. The Report may thus be limited
      to the information / data contributed by the Member. The information /
      data provided in the Report is as current and up to date as provided by
      the Members. The Report is not a guarantee of any particular outcome and
      you may therefore not use any information, in full or in part, as the sole
      basis for any decision you take. ECICI does not accept any responsibility
      for any loss that may arise to you from relying on the information / data
      in the Report. ECICI will use all reasonable skill and care in the supply
      of the information / data to you. However since we obtain the information
      / data from the Member, ECICI cannot guarantee or warranty that the
      information contained in the Report is complete, accurate, up-to-date or
      error-free. Any information contained herein does not reflect the views of
      ECICI or its directors or employees. This message contains legally
      privileged and/or confidential information. If you are not the intended
      recipient(s) of this message, you are hereby notified that any
      dissemination, distribution or copying of this Report is strictly
      prohibited. If you have received this Report in error, please notify the
      sender immediately and delete this Report from your computer and all your
      records.
    </p>
  </div>
</div>
